import LegacyNeedsAttentionDashboardView from './needs_attention_dashboard';

export {
  LegacyNeedsAttentionDashboardView
};
